<script setup>
const { model } = defineProps(['model'])
definePageMeta({
  layout: 'default',
})

const categoryId = computed(() => model?.contentLink?.id)

const {
  data,
  pageNumber,
  onPageChange,
  pending,
} = usePaginatedArticles(categoryId)

const { showFooterForm } = useLayoutFlags()
showFooterForm.value = true
</script>

<template>
  <div class="article-feed-page">
    <HeroBlock
      color="navy"
      :title="model.pageTitle.value"
      :description="model.pageSummary.value"
    />

    <FeaturedArticleCard
      :image="model?.featuredArticlePage.expandedValue.aprimoThumbnailImage.url"
      :image-height="model?.featuredArticlePage.expandedValue.aprimoThumbnailImage.height"
      :image-width="model?.featuredArticlePage.expandedValue.aprimoThumbnailImage.width"
      :image-alt-text="model?.featuredArticlePage.expandedValue.thumbnailImageAltText.value"
      :heading="model?.featuredArticlePage.expandedValue.pageTitle.value"
      :description="model?.featuredArticlePage.expandedValue.pageSummary.value"
      :category="data?.featuredArticleCategory"
      :category-url="data?.featuredArticleUrl"
      :url="model?.featuredArticlePage.expandedValue.url"
    />

    <div class="container-fluid mb-20">
      <TopicFilterBlock
        heading="Filter by Topic"
        :items="data?.articleFilters"
      />
      <UiLoaderOverlay :pending="pending">
        <ArticleListingBlock
          :cards="data?.articles"
          :show-article-summaries="model.showArticleSummaries?.value"
          :show-article-topics="model.showArticleTopics?.value"
        />
      </UiLoaderOverlay>
      <PaginationBlock
        v-if="data?.articlePageCount && data.articlePageCount > 1"
        :total="data.articleCount"
        :items-per-page="9"
        :on-page-change="onPageChange"
        :current-page="pageNumber"
        pagination-class="m-auto mt-0"
      />
    </div>
  </div>
</template>
